import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useDeviceSize } from "hooks";
import { useState } from "react";
import type { Airport } from "@airhelp/react";
import { trackCustomEvent, trackUAEvent } from "utils/tracking";
import type { AutocompleteFormProps } from "../AutocompleteForm.d";
import { AutocompleteMultilegForm } from "./AutocompleteMultilegForm";
import {
  CONNECTING_FLIGHT_DIRECT_TAB_CLICK,
  CONNECTING_FLIGHT_DIRECT_TAB_CLICK_EVENT_UA,
  CONNECTING_FLIGHT_MULTILEG_TAB_CLICK,
  CONNECTING_FLIGHT_MULTILEG_TAB_CLICK_EVENT_UA,
} from "./gaEvents";

export const AutocompleteFormTabs = ({ ctaVariant = "secondary", buttonText }: AutocompleteFormProps) => {
  const { isMobile } = useDeviceSize();

  const [departureAirport, setDepartureAirport] = useState<Airport>(null);
  const [arrivalAirport, setArrivalAirport] = useState<Airport>(null);

  const trackDirectFlightClick = () => {
    trackUAEvent(CONNECTING_FLIGHT_DIRECT_TAB_CLICK_EVENT_UA);
    trackCustomEvent(CONNECTING_FLIGHT_DIRECT_TAB_CLICK);
  };

  const trackMultilegFlightClick = () => {
    trackUAEvent(CONNECTING_FLIGHT_MULTILEG_TAB_CLICK_EVENT_UA);
    trackCustomEvent(CONNECTING_FLIGHT_MULTILEG_TAB_CLICK);
  };

  if (!isMobile) return <AutocompleteMultilegForm ctaVariant={ctaVariant} buttonText={buttonText} />;

  return (
    <Tabs isFitted display="block" mt={4} w="full" ml={0} px={0} overflow="visible">
      <TabList>
        <Tab onClick={trackDirectFlightClick}>Direct flight</Tab>
        <Tab onClick={trackMultilegFlightClick}>Connecting flight</Tab>
      </TabList>
      <TabPanels pt={6}>
        <TabPanel p={0}>
          <AutocompleteMultilegForm
            ctaVariant={ctaVariant}
            buttonText={buttonText}
            departureAirport={departureAirport}
            arrivalAirport={arrivalAirport}
            setDepartureAirport={setDepartureAirport}
            setArrivalAirport={setArrivalAirport}
          />
        </TabPanel>
        <TabPanel p={0}>
          <AutocompleteMultilegForm
            ctaVariant={ctaVariant}
            buttonText={buttonText}
            departureAirport={departureAirport}
            arrivalAirport={arrivalAirport}
            setDepartureAirport={setDepartureAirport}
            setArrivalAirport={setArrivalAirport}
            isMultiLeg
            withDefaultField
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
